<template>
    <div class="contact">
        <Carousel :list="config.banner.contact"/>
        <div class="row main">
            <div  id="dituContent" class="col-md-5"></div>
            <div  id="center" class="col-md-1"></div>
            <div class="col-md-6 info">
                <p class="title">{{config.name}}</p>
                <p>联系人：{{config.contact.name}}</p>
                <p>联系电话：{{config.contact.tel}}</p>
                <p>QQ：{{config.contact.QQ}}</p>
                <p>邮箱：{{config.contact.email}}</p>
                <p>联系地址：{{config.contact.address}}</p>
            </div>
        </div>
    </div>
</template>
<script>
    import Carousel from '@/components/Carousel'
    export default {
        components: {
            Carousel
        },
        data(){
            return {
                config
            }
        },
        mounted(){
            var map = new AMap.Map("dituContent", {
                resizeEnable: true,
                center: [104.031112,31.157222],
                zoom: 13
            });
            //添加marker标记
            map.clearMap();
            var marker = new AMap.Marker({
                map: map,
                position: [104.031112,31.157222]
            });
            //鼠标点击marker弹出自定义的信息窗体
            AMap.event.addListener(marker, 'click', function () {
                infoWindow.open(map, marker.getPosition());
            });
            //实例化信息窗体
            var title = '什邡市鹏成化工有限公司',
                content = [];
            content.push("地址：四川省德阳市什邡市S106");
            content.push("电话："+config.footerTel);
            content.push("<a href='https://www.amap.com/search?query=%E4%BB%80%E9%82%A1%E5%B8%82%E9%B9%8F%E6%88%90%E5%8C%96%E5%B7%A5%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&city=510600&geoobj=104.028128%7C31.155943%7C104.033828%7C31.158593&zoom=18'>详细信息</a>");
            var infoWindow = new AMap.InfoWindow({
                isCustom: true,  //使用自定义窗体
                content: createInfoWindow(title, content.join("<br/>")),
                offset: new AMap.Pixel(16, -45)
            });

            //构建自定义信息窗体
            function createInfoWindow(title, content) {
                var info = document.createElement("div");
                info.className = "custom-info input-card content-window-card";

                //可以通过下面的方式修改自定义窗体的宽高
                //info.style.width = "400px";
                // 定义顶部标题
                var top = document.createElement("div");
                var titleD = document.createElement("div");
                var closeX = document.createElement("img");
                top.className = "info-top";
                titleD.innerHTML = title;
                closeX.src = "https://webapi.amap.com/images/close2.gif";
                closeX.onclick = closeInfoWindow;

                top.appendChild(titleD);
                top.appendChild(closeX);
                info.appendChild(top);

                // 定义中部内容
                var middle = document.createElement("div");
                middle.className = "info-middle";
                middle.style.backgroundColor = 'white';
                middle.innerHTML = content;
                info.appendChild(middle);

                // 定义底部内容
                var bottom = document.createElement("div");
                bottom.className = "info-bottom";
                bottom.style.position = 'relative';
                bottom.style.top = '0px';
                bottom.style.margin = '0 auto';
                var sharp = document.createElement("img");
                sharp.src = "https://webapi.amap.com/images/sharp.png";
                bottom.appendChild(sharp);
                info.appendChild(bottom);
                return info;
            }

            //关闭信息窗体
            function closeInfoWindow() {
                map.clearInfoWindow();
            }

            infoWindow.open(map, marker.getPosition());
        }
    }
</script>
<style lang="less">
    .contact{
        .main{
            width: 90%;
            max-width: 1200px;
            margin: 50px auto;
            #dituContent{
                height: 300px;
            }
            .info{
                box-shadow: 0 0 5px #999;
                border-radius: 10px;
                padding: 20px;
                height: 300px;
                line-height: 30px;
                .title{
                    font-size: 26px;
                    font-weight: bold;
                    margin-bottom: 30px;
                }
            }
        }
        #dituContent{
            .content-window-card {
                position: relative;
                box-shadow: none;
                bottom: 0;
                left: 0;
                width: auto;
                padding: 0;
            }

            .content-window-card p {
                height: 2rem;
            }

            .custom-info {
                border: solid 1px silver;
            }

            div.info-top {
                position: relative;
                background: none repeat scroll 0 0 #F9F9F9;
                border-bottom: 1px solid #CCC;
                border-radius: 5px 5px 0 0;
            }

            div.info-top div {
                display: inline-block;
                color: #333333;
                font-size: 14px;
                font-weight: bold;
                line-height: 31px;
                padding: 0 10px;
            }

            div.info-top img {
                position: absolute;
                top: 11px;
                right: 4px;
                transition-duration: 0.25s;
            }

            div.info-top img:hover {
                box-shadow: 0px 0px 5px #000;
            }

            div.info-middle {
                font-size: 12px;
                padding: 10px 6px;
                line-height: 20px;
            }

            div.info-bottom {
                height: 0px;
                width: 100%;
                clear: both;
                text-align: center;
            }

            div.info-bottom img {
                position: relative;
                z-index: 104;
            }

            span {
                margin-left: 5px;
                font-size: 11px;
            }

            .info-middle img {
                float: left;
                margin-right: 6px;
            }
        }
    }
    @media (max-width: 992px){
        .contact{
            .main{
                .center{
                    display: none;
                }
                .info{
                    margin-top: 50px;
                    height: auto;
                }
            }
        }
    }
</style>
